import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import { emphasize } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const BreadcrumbLink = styled(Link)(({ theme }) => ({
  "&, &:visited": {
    color: `${theme.palette.text.primary}`,
  },
  "&:hover": {
    textDecoration: "none",
  },
}));

const StyledBreadcrumb = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  height: theme.spacing(3),
  color: theme.palette.grey[800],
  fontWeight: "normal",
  cursor: "pointer",
  "&:hover, &:focus": {
    backgroundColor: theme.palette.grey[300],
  },
  "&:active": {
    boxShadow: "1px 1px 1px ",
    backgroundColor: emphasize(theme.palette.secondary.main, 0.12),
  },
}));

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  padding: theme.spacing(0, 0, 2, 0),
}));

export default function Breadcrumb({
  path = [],
}: {
  path?: { path: string; label: string }[];
}) {
  const length = path.length;

  return (
    <StyledBreadcrumbs aria-label="breadcrumb">
      <BreadcrumbLink to="/admin">
        <StyledBreadcrumb label="Admin" />
      </BreadcrumbLink>
      {path.map(({ path, label }, i) =>
        i + 1 !== length ? (
          <BreadcrumbLink key={path} to={path}>
            <StyledBreadcrumb label={label} />
          </BreadcrumbLink>
        ) : (
          <StyledBreadcrumb key={path} label={label} />
        ),
      )}
    </StyledBreadcrumbs>
  );
}
